export default __webpack_public_path__ + "static/banner-should-you-buy-a-new-or-used-car-b3c31eb5dd145b788905693bb958c729.jpg";